import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt, faPhone, faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
import './footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-50">
      <div className="container pt-60 pb-30">
        
        {/* --- SECTION HAUTE : Logo, Description & Liens Rapides --- */}
        <div className="row mb-50">
          {/* Colonne 1 : Brand & Social */}
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <Link to="/" className="d-block mb-20">
              <img alt="Cible RH" src="assets/imgs/cb_white.svg" className="footer-logo" />
            </Link>
            <p className="font-sm text-white-50 mb-20 pe-lg-5">
              {t("footerDescription") || "Votre partenaire privilégié pour le recrutement et le conseil RH au Cameroun et en Afrique."}
            </p>
            <div className="footer-socials">
              <Link to="https://www.facebook.com/ciblerhemploi" target="_blank" className="social-icon">
                <FontAwesomeIcon icon={faFacebookF} />
              </Link>
              <Link to="https://twitter.com/cible_rh_emploi" target="_blank" className="social-icon">
                <FontAwesomeIcon icon={faTwitter} />
              </Link>
              <Link to="https://www.linkedin.com/company/cible-rh-emploi/" target="_blank" className="social-icon">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </Link>
            </div>
          </div>

          {/* Colonne 2 : Raccourcis */}
          <div className="col-lg-2 col-md-4 col-6 mb-4 mb-lg-0">
            <h6 className="footer-title">{t("textShortcuts")}</h6>
            <ul className="footer-links">
              <li><Link to="/search">{t("textAllJobs")}</Link></li>
              <li><Link to="https://www.ciblerh-emploi.com/contact/" target="_blank">{t("textContact")}</Link></li>
              <li><Link to="https://groupe-cible.com/nos-entreprises/" target="_blank">{t("textCompany")}</Link></li>
            </ul>
          </div>

          {/* Colonne 3 : Liens du Groupe */}
          <div className="col-lg-3 col-md-4 col-6">
            <h6 className="footer-title">{t("footerTitleLinks")}</h6>
            <ul className="footer-links">
              <li><Link to="https://groupe-cible.com/" target="_blank">{t("Groupe Cible ")}</Link></li>
              <li><Link to="https://www.ciblerh-emploi.com" target="_blank">{t("Cible Emploi rh")}</Link></li>
              <li><Link to="https://cabinetcible.com/" target="_blank">{t("Cible Etudes & Conseil")}</Link></li>
            </ul>
          </div>

           {/* Colonne 4 : Mobile Apps (Optionnel - Placeholder propre) */}
           <div className="col-lg-3 col-md-4 col-12 mt-4 mt-md-0">
                <div className="app-download-box p-4 rounded-3 text-center text-md-start">
                    <p className="text-white font-xs fw-bold mb-2">Bientôt disponible sur</p>
                    <div className="d-flex gap-2 justify-content-center justify-content-md-start">
                        <img src="/assets/imgs/template/icons/app-store.png" alt="App Store" className="app-icon opacity-50" style={{height: 35}} />
                        <img src="/assets/imgs/template/icons/android.png" alt="Google Play" className="app-icon opacity-50" style={{height: 35}} />
                    </div>
                </div>
           </div>
        </div>

        {/* --- SEPARATEUR --- */}
        <div className="footer-divider"></div>

        {/* --- SECTION CONTACTS (Douala / Yaoundé / Kribi) --- */}
        <div className="row mt-40 contact-grid">
            {/* Douala */}
            <div className="col-md-4 col-sm-12 mb-4">
                <h6 className="city-title">Douala</h6>
                <ul className="contact-list">
                    <li>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="c-icon" />
                        <span>Carrefour Ancien Dalip, Immeuble Amicale Chine-Cameroun Akwa (BP 3462)</span>
                    </li>
                    <li>
                        <FontAwesomeIcon icon={faPhone} className="c-icon" />
                        <a href="tel:+237699905558">+237 6 99 90 55 58</a>
                    </li>
                </ul>
            </div>

            {/* Yaoundé */}
            <div className="col-md-4 col-sm-12 mb-4">
                <h6 className="city-title">Yaoundé</h6>
                <ul className="contact-list">
                    <li>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="c-icon" />
                        <span>Immeuble Inter voyages, Rue Valery Giscard Destaing (BP 1059)</span>
                    </li>
                    <li>
                        <FontAwesomeIcon icon={faPhone} className="c-icon" />
                        <a href="tel:+237699881623">+237 6 99 88 16 23</a>
                    </li>
                </ul>
            </div>

            {/* Kribi */}
            <div className="col-md-4 col-sm-12 mb-4">
                <h6 className="city-title">Kribi</h6>
                <ul className="contact-list">
                    <li>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="c-icon" />
                        <span>Mokolo face Commissariat Central (BP 3462)</span>
                    </li>
                    <li>
                        <FontAwesomeIcon icon={faPhone} className="c-icon" />
                        <a href="tel:+237696262568">+237 6 96 26 25 68</a>
                    </li>
                </ul>
            </div>
            
            {/* Infos Générales (Email/Site) pour éviter la répétition */}
            <div className="col-12 text-center mt-3 pt-3 border-top border-secondary">
                 <span className="mx-3 d-inline-block py-1">
                    <FontAwesomeIcon icon={faEnvelope} className="text-primary me-2" />
                    <a href="mailto:ciblerh@groupe-cible.com" className="text-white-50">ciblerh@groupe-cible.com</a>
                 </span>
                 <span className="mx-3 d-inline-block py-1">
                    <FontAwesomeIcon icon={faGlobe} className="text-primary me-2" />
                    <a href="https://www.ciblerh-emploi.com" target="_blank" rel="noreferrer" className="text-white-50">www.ciblerh-emploi.com</a>
                 </span>
            </div>
        </div>

        {/* --- COPYRIGHT --- */}
        <div className="footer-bottom mt-50 pt-30 border-top border-dark-subtle">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <span className="font-xs text-white-50">
                Copyright &copy; {currentYear}. CibleRH. Tous droits réservés.
                <br className="d-md-none" /> Designed by <Link className="text-white fw-bold" to="#">WeDev Corp</Link>
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
              <div className="footer-bottom-links">
                <Link to="#">Privacy Policy</Link>
                <Link to="#">Terms & Conditions</Link>
                <Link to="#">Security</Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;